import {Observable} from "rxjs";
import {NgSecurityService} from "@tci/core";
import {Injectable} from "@angular/core";

/**
 * interface ITenantVPNServiceProvider
 */
export interface ITenantVPNServiceProvider {
    /**
     * Returns VPN connection by Id
     * @param username
     * @param vpnConnectionId
     */
    getVpnConnectionById(username: string, vpnConnectionId: string): Observable<any>;
}

@Injectable()
export abstract class TCITenantBaseVPNServiceProvider implements ITenantVPNServiceProvider {
    abstract getVpnConnectionById(username: string, vpnConnectionId: string): Observable<any>;
}
